const RESULT_CLICK_CATEGORY = /^search-(.+)-(list|grid)$/
const TOP_RESULT_LIMIT = 3

const normalizeContentType = contentType => {
  switch (contentType) {
    case 'articles':
      return 'article'
    case 'projects':
      return 'project'
    case 'products':
      return 'product'
    case 'companies':
      return 'company'
    case 'experts':
      return 'expert'
    default:
      return contentType || ''
  }
}

const activeFiltersFromPath = searchType => {
  if (!window.location || !window.location.pathname) return ''

  const marker = `/${searchType}`
  const markerIndex = window.location.pathname.indexOf(marker)
  if (markerIndex < 0) return ''

  return decodeURIComponent(window.location.pathname.slice(markerIndex + marker.length))
    .replace(/^\/+/, '')
    .replace(/\//g, '|')
}

const sendSearchResultClickToGTM = ({ category, label, value, version, action }) => {
  const match = category.match(RESULT_CLICK_CATEGORY)
  if (!match || action !== 'click-result') return

  const [, searchType, viewMode] = match
  const [contentType, contentId] = (value || '').split('/')
  const position = parseInt(version, 10)

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'custom_event',
    type: 'click',
    internalType: 'onclick',
    dimensions: {
      category: 'search-result',
      action: '1823,search-interaction,click',
      label: 'Search interaction',
      dim1: contentId || '',
      dim2: document.documentElement.lang || '',
      dim3: label || '',
      dim4: searchType,
      dim5: normalizeContentType(contentType),
      dim6: version || '',
      dim7: position <= TOP_RESULT_LIMIT ? 'top' : 'bottom',
      dim8: viewMode,
      dim9: activeFiltersFromPath(searchType)
    }
  })
}

export const sendClickEventToInsights = (category, label, value, version, action = 'click-result') => {
  sendSearchResultClickToGTM({ category, label, value, version, action })
  if (window.adInsights && window.adInsights.e) {
    window.adInsights.e(category, action, label, value, version)
  }
}

export const insightsAttrs = ({ category = '', label = '', value, version }) => ({
  'data-insights-category': category,
  'data-insights-label': label,
  ...(value ? { 'data-insights-value': value } : {}),
  ...(version ? { 'data-insights-version': version } : {})
})
